import React from 'react';
import { Leaf, Instagram, Facebook, Twitter } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#0A0A0A] text-[#E8DFD5] py-16 border-t border-[#2A2A2A]" data-id="element-99">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-100">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12" data-id="element-101">
          <div className="col-span-1 md:col-span-2" data-id="element-102">
            <a href="#" className="flex items-center space-x-2 mb-6 group inline-flex" data-id="element-103">
              <Leaf className="w-8 h-8 text-[#D4AF37] group-hover:text-[#F0D060] transition-colors" data-id="element-104" />
              <span className="text-2xl font-semibold text-[#F5F0EB]" data-id="element-105">
                SGHarems.com 新加坡后宫网
              </span>
            </a>
            <p className="text-[#999999] max-w-sm mb-8 leading-relaxed" data-id="element-106">
              Your sanctuary for holistic wellness and relaxation. Experience
              the ultimate in therapeutic care and rejuvenation.
            </p>
            <div className="flex space-x-4" data-id="element-107">
              <a href="#" className="text-[#999999] hover:text-[#D4AF37] transition-colors" data-id="element-108">
                <Instagram className="w-6 h-6" data-id="element-109" />
              </a>
              <a href="#" className="text-[#999999] hover:text-[#D4AF37] transition-colors" data-id="element-110">
                <Facebook className="w-6 h-6" data-id="element-111" />
              </a>
              <a href="#" className="text-[#999999] hover:text-[#D4AF37] transition-colors" data-id="element-112">
                <Twitter className="w-6 h-6" data-id="element-113" />
              </a>
            </div>
          </div>

          <div data-id="element-114">
            <h4 className="text-[#F5F0EB] font-semibold mb-6 uppercase tracking-wider text-sm" data-id="element-115">
              Quick Links
            </h4>
            <ul className="space-y-4" data-id="element-116">
              <li data-id="element-117">
                <a href="#services" className="text-[#999999] hover:text-[#D4AF37] transition-colors" data-id="element-118">
                  Our Services
                </a>
              </li>
              <li data-id="element-119">
                <a href="#about" className="text-[#999999] hover:text-[#D4AF37] transition-colors" data-id="element-120">
                  About Us
                </a>
              </li>
              <li data-id="element-121">
                <a href="#team" className="text-[#999999] hover:text-[#D4AF37] transition-colors" data-id="element-122">
                  Meet the Team
                </a>
              </li>
              <li data-id="element-123">
                <a href="#pricing" className="text-[#999999] hover:text-[#D4AF37] transition-colors" data-id="element-124">
                  Pricing & Packages
                </a>
              </li>
              <li data-id="element-125">
                <a href="#contact" className="text-[#999999] hover:text-[#D4AF37] transition-colors" data-id="element-126">
                  Contact & Booking
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-127">
            <h4 className="text-[#F5F0EB] font-semibold mb-6 uppercase tracking-wider text-sm" data-id="element-128">
              Legal
            </h4>
            <ul className="space-y-4" data-id="element-129">
              <li data-id="element-130">
                <a href="#" className="text-[#999999] hover:text-[#D4AF37] transition-colors" data-id="element-131">
                  Privacy Policy
                </a>
              </li>
              <li data-id="element-132">
                <a href="#" className="text-[#999999] hover:text-[#D4AF37] transition-colors" data-id="element-133">
                  Terms of Service
                </a>
              </li>
              <li data-id="element-134">
                <a href="#" className="text-[#999999] hover:text-[#D4AF37] transition-colors" data-id="element-135">
                  Cancellation Policy
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-[#2A2A2A]" data-id="element-136">
          <h4 className="text-[#F5F0EB] font-semibold mb-4 uppercase tracking-wider text-sm text-center" data-id="element-137">
            友情链接 / Friendly Links
          </h4>
          <div className="flex flex-wrap justify-center gap-x-4 gap-y-2 mb-8" data-id="element-138">
            {['sglonelyguy.me', 'ttvip.life', 'locanto.space', 'kkbaby.site', 'xfy8.com', 'sgbeautycastle.live', 'shiok26.site', 'sgharem.site', 'shiok8.xyz', 'geylang777.info', 'ttvip-62.site', 'geylang666.me', 'isyou.net'].map(site => <a key={site} href={`https://www.${site}`} target="_blank" rel="noopener noreferrer" className="text-[#999999] hover:text-[#D4AF37] transition-colors text-sm" data-id="element-139">
                {site}
              </a>)}
          </div>
        </div>

        <div className="pt-4 border-t border-[#2A2A2A] text-center text-[#999999] text-sm" data-id="element-140">
          <p data-id="element-141">
            &copy; {new Date().getFullYear()} SGHarems.com 新加坡后宫网. All
            rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}